export default __webpack_public_path__ + "static/media/ScreenShot_1.a1f01491.jpg";